import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BuildingManagementService } from 'src/app/building-managment/building-management.service';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { Subscription } from 'rxjs';
import { LocalizationService } from '../shared/services/localization.service';

@Component({
  selector: 'app-building-management',
  templateUrl: './building-management.component.html',
  styleUrls: ['./building-management.component.scss'],
})
export class BuildingManagementComponent implements OnInit, OnDestroy {
  @Input() buildingsList: any;

  subscription: Subscription | undefined;
  sharedData: any;

  constructor(
    public buildingManagementService: BuildingManagementService,
    public sharedDataService: SharedDataService,
    private localizationService: LocalizationService
  ) {}

  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.subscription = this.sharedDataService.currentData.subscribe(
      (sharedData) => {
        this.sharedData = sharedData;
      }
    );
  }
  /**
   * @description ##buildingAdded function is the emitted function from add building
   *              component. On successful creation of building, building list will
   *              be updated and then pass on to the app-building-list component.
   * @returns { void}
   */

  buildingAdded(): void {
    this.buildingManagementService
      .getAllBuildingsBySiteId(this.sharedData?.selectedSite?.siteId)
      .subscribe({
        next: (buildings: any) => {
          this.buildingsList = buildings;
          if (this.buildingsList.length <= 0)
            this.buildingManagementService.buildingsView = false;
          else this.buildingManagementService.buildingsView = true;
        },
        error: (err: any) => {},
      });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
